import React, { useEffect, useState } from "react";
import "./styles.scss";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import stringJp from '../../constants/stringJP';
import { AddPerson } from "../../components/buttons/addPerson";
import { ButtonSubmit } from "../../components/buttons/buttonSubmit";
import { DeleteMember } from "../../components/buttons/deleteMember";
import ListMembers from "../../services/get-members";
import { useHistory } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from "@material-ui/core";
import { ArrowLeftOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import { Skeleton } from 'antd';
import useWindowDimensions from "../../components/useWindowDemision";
import { useSelector } from "react-redux";

export default function AddFamily() {

    let history = useHistory();
    const [dataMember, setDataMember] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [count, setCount] = useState(0);
    const urlList = new URL(window.location.href);
    const paramsUrl = urlList.searchParams;
    const account_id = paramsUrl.get("account_id");
    const security_key = localStorage.getItem('security_key');
    const { height, width } = useWindowDimensions();
    const dataMembers = JSON.parse(localStorage.getItem("dataMember"));
    // const dataUserAdmin = JSON.parse(localStorage.getItem("DATA_MEMBER_ADMIN"));

    const dataUser = useSelector(state => state.chart?.dataChart?.user);

    const styleTitleTop ={
        display: 'flex',
        height: 50, width: '100%', 
        justifyContent:'center',
    }
    useEffect( () => {
        if (!history?.location?.state?.isCancel || count !== 0) {
            const params = {
                account_id: account_id,
                security_key: security_key,
            };
            ListMembers.getDataMember(
                params,
                async (res) => {
                    localStorage.setItem("DATA_MEMBER_FM", JSON.stringify([...res?.data]));
                    const dataUserFamily = await JSON.parse(localStorage.getItem("DATA_MEMBER_FM"));
                    if(dataUserFamily !== null ){
                        setDataMember(dataUserFamily);
                    }
                    setIsLoading(false);
                },
                () => { }
            );
        } else {
            setDataMember(dataMembers);
            setIsLoading(false);
        };

        return () => { // This code runs when component is unmounted
            setDataMember([]);
            setIsLoading(true);
        }
    }, [count]) // eslint-disable-line react-hooks/exhaustive-deps

    const listGender = [
        { id: null, value: "" },
        { id: 1, value: "男　性" },
        { id: 2, value: "女　性" },
        { id: 3, value: "その他" },
        { id: 4, value: "未回答" }
    ];

    const handleShowGender = (gender) => {
        const nameGender = listGender?.find(item => gender === 0 ? item.id === null : item.id === gender)
        return nameGender?.value

    };
    if (!history?.location?.state?.isCancel || count !== 0) {
        localStorage.setItem("dataMember", JSON.stringify(dataMember));
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleRedirectEditPage = ({ index, isGender }) => {
        if ((index === 0 && dataUser?.birthday_changeable !== 1) && !isGender) {
            setOpen(true);
        } else {
            if (dataMember?.length === 0) {
                if (dataUser?.birthday_changeable !== 1 && !isGender) {
                    setOpen(true);
                } else {
                    history.push(`/info-member?account_id=${account_id}&index_card=${0}`)
                }
            } else {
                history.push(`/info-member?account_id=${account_id}&index_card=${index}`)
            }
        }
    };
    const heightList = height - 136;

    return (
        
        <div className="add-family-page" style={{ minHeight: height }} >
        
            <div style={{ width: '100%', height:40, marginTop:-10}}>
                <div style={{...styleTitleTop, position: "absolute", top:10}}>
                    <h6 className="text-title-top"> 家族構成の編集 </h6>
                </div>
                {/* <div onClick={() => history.push(
                    `/?account_id=${account_id}
                    &company_code=${localStorage.getItem('company_code')}
                    &store_code=${localStorage.getItem('store_code')}
                    &instore_code=${localStorage.getItem('instore_code')}
                    &security_key=${localStorage.getItem('security_key')}
                    &area_code=${localStorage.getItem('area_code')}
                    &timerange_code=${localStorage.getItem('timerange_code')}
                    &purchase_flag=${localStorage.getItem('purchase_flag')}
                    &cart_flag=${localStorage.getItem('cart_flag')}
                    &add_flag=${localStorage.getItem('add_flag')}`
                )}> */}
                <div onClick={() => history.goBack()}>
                    <ArrowLeftOutlined className ="icon-goBack"/> 
                </div>
            </div>
            <div className="list" style={{ height: heightList-30, paddingTop:10 }}>
                {isLoading === true ? <Skeleton active /> :
                
                    <div>
                        {dataMember?.length === 0 && dataUser !== undefined ?
                            <div className="list_member">
                                <Container className="item" style={{width: width-20}}>
                                    <div className="index-value">
                                        {stringJp.index_values}
                                    </div>
                                    <div className="card-member">
                                        <div>
                                            <Row className="row">
                                                <Col
                                                    xs={6}
                                                    style={{
                                                        paddingLeft: 51,
                                                        paddingTop: 4,
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    {stringJp.label_name_member}
                                                </Col>
                                                <Col xs={4} style={{ textAlign: "center" }}>
                                                    {dataUser.account_name}
                                                </Col>
                                                <Col xs={2}></Col>
                                            </Row>
                                            {/* row 1 */}
                                            <hr />
                                            <Row
                                                className="row"
                                                style={{ paddingTop: 7, paddingBottom: 2 }}
                                            >
                                                <Col xs={6} style={{ paddingLeft: 51, textAlign: "left" }}>
                                                    {stringJp.label_birthday_member}
                                                </Col>
                                                <Col xs={4} style={{ textAlign: "center" }}>
                                                    {dataUser.birthday ? dataUser.birthday :'未設定'}
                                                </Col>
                                                <Col xs={2} className="icon_arrow">
                                                    {dataUser?.birthday_changeable !== 1 ? "" 
                                                    : <ArrowForwardIosIcon onClick={() => handleRedirectEditPage({})} />}
                                                </Col>
                                            </Row>
                                            {/* row 2 */}
                                            <hr />
                                            <Row className="row row3" style={{ marginTop: 23 }}>
                                                <Col xs={6} style={{ paddingLeft: 51, textAlign: "left" }}>
                                                    {stringJp.label_gender_member}
                                                </Col>
                                                <Col xs={4} style={{ textAlign: "center" }}>
                                                    {handleShowGender(dataUser.gender)? handleShowGender(dataUser.gender) : '未設定'} 
                                                </Col>
                                                <Col xs={2} className="icon_arrow">
                                                    <ArrowForwardIosIcon
                                                        onClick={() => handleRedirectEditPage({ isGender: true })}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    {/* row 3 */}
                                </Container>

                            </div> :
                            <div className="list_member">
                                {dataMember?.map((item, index) => (
                                    <Container key={item.name} className="item" style={{width: width-20}}>
                                        <div className="index-value">
                                            {index + 1} / {dataMember?.length}
                                        </div>
                                        <div className="card-member">
                                            <div>
                                                <Row className="row">
                                                    {index === 0 ? (
                                                        ""
                                                    ) : (
                                                        <Col xs={1}>
                                                            <DeleteMember 
                                                                dataMember={dataMember} 
                                                                index={index} 
                                                                setDataMember={setDataMember} 
                                                                count={count} 
                                                                setCount={setCount} />
                                                        </Col>
                                                    )}
                                                    {index === 0 ? (
                                                        <Col
                                                            xs={6}
                                                            style={{
                                                                paddingLeft: 51,
                                                                paddingTop: 4,
                                                                textAlign: "left",
                                                            }}
                                                        >
                                                            {stringJp.label_name_member}
                                                        </Col>
                                                    ) : (
                                                        <Col
                                                            xs={5}
                                                            style={{
                                                                paddingLeft: 23,
                                                                paddingTop: 4,
                                                                textAlign: "left",
                                                            }}
                                                        >
                                                            {stringJp.label_name_member}
                                                        </Col>
                                                    )}

                                                    <Col xs={4} style={{ textAlign: "center" }}>
                                                        {item.name}
                                                    </Col>
                                                    {index === 0 ? (
                                                        <Col xs={2}></Col>
                                                    ) : (
                                                        <Col xs={2} className="icon_arrow">
                                                            <ArrowForwardIosIcon onClick={() => handleRedirectEditPage({ index })} />
                                                            <Dialog
                                                                open={open}
                                                                onClose={handleClose}
                                                                aria-labelledby="alert-dialog-title"
                                                                aria-describedby="alert-dialog-description"
                                                                className="dialog-date"
                                                            >
                                                                <DialogTitle id="alert-dialog-title" className="dialog-title-date">{stringJp.label_list_dialog}</DialogTitle>
                                                                <hr style={{ margin: 0 }} />
                                                                <DialogActions className="dialog-actions-date">
                                                                    <Button onClick={handleClose} className="button-ok">
                                                                        <p>{stringJp.label_list_dialog_button}</p>
                                                                    </Button>
                                                                </DialogActions>
                                                            </Dialog>
                                                        </Col>
                                                    )}

                                                </Row>
                                                {/* row 1 */}
                                                <hr />
                                                <Row
                                                    className="row"
                                                    style={{ paddingTop: 7, paddingBottom: 2 }}
                                                >
                                                    <Col xs={6} style={{ paddingLeft: 51, textAlign: "left" }}>
                                                        {stringJp.label_birthday_member}
                                                    </Col>
                                                    <Col xs={4} style={{ textAlign: "center" }}>
                                                        {item.birthday? item.birthday : '未設定'}
                                                    </Col>
                                                    <Col xs={2} className="icon_arrow">
                                                        {index === 0 && dataUser?.birthday_changeable !== 1 ? "" : <ArrowForwardIosIcon onClick={() => handleRedirectEditPage({ index })} />}
                                                        {/* <ArrowForwardIosIcon onClick={() => handleRedirectEditPage({ index })} /> */}
                                                    </Col>
                                                </Row>
                                                {/* row 2 */}
                                                <hr />
                                                <Row className="row row3" style={{ marginTop: 23 }}>
                                                    <Col xs={6} style={{ paddingLeft: 51, textAlign: "left" }}>
                                                        {stringJp.label_gender_member}
                                                    </Col>
                                                    <Col xs={4} style={{ textAlign: "center" }}>
                                                        {handleShowGender(item.gender)?handleShowGender(item.gender):'未設定'}
                                                    </Col>
                                                    <Col xs={2} className="icon_arrow">
                                                        <ArrowForwardIosIcon
                                                            onClick={() => handleRedirectEditPage({ index, isGender: true })}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                        {/* row 3 */}
                                    </Container>
                                ))}
                            </div>
                        }

                        {dataMember.length === 10 ? "" :
                            <AddPerson />
                        }
                    </div>
                }
            </div>
            <div className="btn-sbm" >
                <ButtonSubmit />
            </div>
        </div>
    );
}
